// Servicio para obtener información de envíos
const API_URL = process.env.REACT_APP_NATIONALS;

export async function getTrackingInfo(guias = []) {
  if (!Array.isArray(guias)) guias = [guias];
  const url = `${API_URL}/orders/public/tracking`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ guias }),
    });
    if (!response.ok) {
      throw new Error('Error al obtener la información de rastreo');
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
}
